import React from 'react';
import { Link } from 'react-router-dom'; // For navigation
import imag from '../StyledComponents/img/logo (11).png'

function ForgotPassword() {
  return (
    <div className="forgot-main">
      <div className="log-in-inner">
        <div className="top">
          <div className="top-inner">
            <div className="logo">
              <img src={imag} alt="Logo" className="logo-w" />
            </div>
          </div>
        </div>

        <div className="form" style={{marginTop: '15vh'}}>
          
          <form action="">
            <h2>Forgot Password</h2>
            <p>Enter your registered email to reset your password</p>
            <div className="form-group fullname">
              <label htmlFor="fullname">Email</label>
              <div className="password-container">

              <input type="email" id="fullname" placeholder="" />
              </div>

            </div>
            <div className="btn">
              {/* Use Link for navigation */}
              <Link to="/whooska/admin/ForgotPasswordVerification">Send Code</Link>
            </div>
          </form>
        </div>
  <div className="logos" style={{height: '18.3vh'}}>
              {/* <img src={imag} alt="Logo"  /> */}
            </div>
        <div className="bottom">
          <div className="bottom-inner">
            <div className="text-content">
              <div className="copy">copyright @ WhooshkaTips</div>
              <div className="text">
                This page is for 18+ only. Gamble Responsibly. Visit
                <span> www.gamblinghelponline.org.vic.au</span> or call <br />
                Gambling Help on
                <span>1800 858 858</span>
                The chances are you are about to lose
              </div>
              <div className="policy">
                Privacy Policy | Terms & Conditions
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
